var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewspaper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.199951 2.49999C0.199951 1.28496 1.18492 0.299988 2.39995 0.299988H11.2C12.415 0.299988 13.4 1.28496 13.4 2.49999V13.5C13.4 14.715 14.3849 15.7 15.5999 15.7H2.39995C1.18492 15.7 0.199951 14.715 0.199951 13.5V2.49999ZM3.49995 3.59999H10.1V7.99999H3.49995V3.59999ZM10.1 10.2H3.49995V12.4H10.1V10.2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 4.69999H15.5999C16.815 4.69999 17.7999 5.68496 17.7999 6.89999V12.95C17.7999 13.8613 17.0612 14.6 16.15 14.6C15.2387 14.6 14.5 13.8613 14.5 12.95V4.69999Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewspaper);
export default __webpack_public_path__ + "static/media/newspaper.01ef5efae371852f9eacede1aa4bb5d4.svg";
export { ForwardRef as ReactComponent };